import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFiscalNotasFiscaisCliente } from '@/features/relatorio/page/fiscal/notas-fiscais-cliente/RelatorioFiscalNotasFiscaisCliente';

export const Route = createFileRoute('/a/relatorio/fiscal/notas-fiscais-cliente')({
    component: RelatorioFiscalNotasFiscaisCliente,
});
